export const API_CONFIG = {
  baseUrl: 'https://apiunisol.com/gameshub_backend/api/v1',
  endpoints: {
    otpSend: '/mtn/otp/send',
    otpVerify: '/mtn/otp/verify',
    subscribe: '/mtn/subscribe',
  },
} as const;

export const getApiUrl = (endpoint: string): string =>
  `${API_CONFIG.baseUrl}${endpoint}`;
